import React, { useRef } from 'react';
import './RadioButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function RadioButton({ onChange, option, name, selected }) {
  const nativeRadioButton = useRef(null);

  if (logComponent('RadioButton')) { console.debug('RadioButton rendered'); }

  const handleChange = () => {
    if (logComponent('RadioButton')) { console.debug('RadioButton handleChange'); }
    onChange(option);
  }

  const setNativeRadioButtonRef = (el) => {
    if (logComponent('RadioButton')) { console.debug('RadioButton setNativeRadioButtonRef'); }
    nativeRadioButton.current = el;
  }

  const clickNativeRadioButton = () => {
    if (logComponent('RadioButton')) { console.debug('RadioButton clickNativeRadioButton'); }
    if (nativeRadioButton.current) nativeRadioButton.current.click();
  }

  return (
    <label className="Radio-Button__label">
      <input
        ref={setNativeRadioButtonRef}
        type="radio"
        className="Radio-Button__native-button"
        value={option.text}
        name={name}
        checked={selected}
        onChange={handleChange} />
      <div
        className={'Radio-Button__outline' + (selected ? ' Radio-Button__outline--selected' : '')}
        onClick={clickNativeRadioButton}>
        <FontAwesomeIcon className={'Radio-Button__circle' + (selected ? ' visible' : '')} icon="circle"></FontAwesomeIcon>
      </div>

      {option.text}
    </label>
  );
}